module.exports = __webpack_public_path__ + "static/media/exchange.8fc91497.svg";